/**
 * ACL source of truth dla całej aplikacji.
 *
 * Trzy funkcje:
 * - canManageAdmins: tylko user z role=ADMIN. Może tworzyć/edytować inne konta ADMIN.
 * - canManagePersonnel: ADMIN + EMPLOYEE z position.name in ['Manager', 'Księgowa'].
 *   Może zarządzać pracownikami (EMPLOYEE), zatwierdzać urlopy, edytować ustawienia placówki.
 *   NIE może modyfikować innych adminów ani promować do ADMIN — to wymaga canManageAdmins.
 * - canViewReports: alias dla canManagePersonnel (zachowany dla backward compat).
 *
 * UWAGA: lista pozycji jest hardcoded. Zmiana nazwy stanowiska 'Manager'/'Księgowa'
 * w UI nie wpłynie na backend ACL. Jeśli admin chce dodać kolejną pozycję z dostępem,
 * trzeba edytować POSITIONS_WITH_PERSONNEL_ACCESS i redeploy.
 */
export const POSITIONS_WITH_PERSONNEL_ACCESS = ['Manager', 'Księgowa'];
export function canManageAdmins(user) {
    if (!user)
        return false;
    return user.role === 'ADMIN';
}
export function canManagePersonnel(user) {
    if (!user)
        return false;
    if (user.role === 'ADMIN')
        return true;
    const name = user.position?.name;
    if (!name)
        return false;
    return POSITIONS_WITH_PERSONNEL_ACCESS.includes(name);
}
/** Alias zachowany dla backward compat z M6a v2 — `canManagePersonnel` to przyszły kanon. */
export function canViewReports(user) {
    return canManagePersonnel(user);
}
//# sourceMappingURL=acl.js.map